import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=c71fcfc2&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"
import style0 from "./Skills.vue?vue&type=style&index=0&id=c71fcfc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71fcfc2",
  null
  
)

export default component.exports